import { useState, useEffect } from 'react';

export function useRateLimit() {
  const [retryUntil, setRetryUntil] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!retryUntil) {
      setSecondsLeft(0);
      return;
    }
    const tick = () => {
      const left = Math.ceil((retryUntil - Date.now()) / 1000);
      if (left <= 0) {
        setSecondsLeft(0);
        setRetryUntil(null);
      } else {
        setSecondsLeft(left);
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [retryUntil]);

  const applyRateLimit = (retryAfter) => {
    setRetryUntil(Date.now() + retryAfter * 1000);
  };

  return { secondsLeft, applyRateLimit, isRateLimited: secondsLeft > 0 };
}
